import React from 'react'
import { Switch, Route } from 'react-router'

import CommentPanel from 'screens/CommentPanel'
import OutlinePanel from 'components/Notes/Outline'

function Metapanel() {
  return (
    <Switch>
      <Route path="/app/*/notes/:noteId/comments">
        {function({ match }) {
          return <CommentPanel noteId={match.params.noteId} />
        }}
      </Route>
      <Route path="/app/*/notes/:noteId/outline">
        {function({ match }) {
          return <OutlinePanel noteId={match.params.noteId} />
        }}
      </Route>
    </Switch>
  )
}

export default React.memo(Metapanel)
